import {Component, EventEmitter, Input, Output} from '@angular/core';

import {Language} from 'classes/language';

@Component({
  selector: 'language-dropdown',
  templateUrl: './language-dropdown.component.html',
  styleUrls: ['./language-dropdown.component.css'],
})
export class LanguageDropdownComponent {

  @Input() public languages: Array<Language>;
  @Output() private change: EventEmitter<Language> = new EventEmitter();
  private selectedLanguageIndex: number;

  constructor() {
    this.selectedLanguageIndex = 0;
  }

  public get selectedLanguage(): Language {
    return this.languages[this.selectedLanguageIndex];
  }

  public set selectedLanguage(newLanguage: Language) {
    const index: number = this.languages.findIndex((language) => {
      return language.code === newLanguage.code;
    });

    if (index > -1) {
      this.selectedLanguageIndex = index;
    } else {
      this.selectedLanguageIndex = 0;
    }

    this.change.emit(this.selectedLanguage);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/language-dropdown/language-dropdown.component.ts